// extracted by mini-css-extract-plugin
module.exports = {"link":"ClientLinkPrimary_link__TRqqQ"};